import script from "./RequestToTeamForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestToTeamForm.vue?vue&type=script&setup=true&lang=js"

import "./RequestToTeamForm.vue?vue&type=style&index=0&id=29106e0c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29106e0c"]])

export default __exports__